import { render, staticRenderFns } from "./UnsignedDocs.vue?vue&type=template&id=432067b3&scoped=true"
import script from "./UnsignedDocs.vue?vue&type=script&lang=js"
export * from "./UnsignedDocs.vue?vue&type=script&lang=js"
import style0 from "./UnsignedDocs.vue?vue&type=style&index=0&id=432067b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432067b3",
  null
  
)

export default component.exports